import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../helpers/auth-config';
import './login.css';
import logo from '../logo.png';
import bgImage from '../background.jpg'; // 👈 make sure the image is in src/


const LoginScreen = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance
      .loginRedirect({
        ...loginRequest,
        prompt: 'select_account',
      })
      .catch(error => console.error(error));
  };

  return (
    <div
      className="login-wrapper"
      style={{
        backgroundImage: `linear-gradient(rgba(30,30,30,0.6), rgba(30,30,30,0.6)), url(${bgImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
      }}
    >
      <div className="login-card">
        <img src={logo} alt="Logo" className="login-logo" />
        <h2 className="login-title">Project Expense Tracker</h2>
        <p className="login-subtitle">
          Building a future in which humans live in harmony with nature.
        </p>
        <button className="login-button" onClick={handleLogin}>
          Sign In
        </button>
      </div>
    </div>
  );
};

export default LoginScreen;